import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { AppRatingsAndReviews } from '../AppRatingsAndReviews';
import { TrustpilotDetails } from '../TrustpilotDetails';
const _exp = /*#__PURE__*/() => Flex.Row;
const SocialProofWrapper = /*#__PURE__*/styled(_exp())({
  name: "SocialProofWrapper",
  class: "s1i86j0l",
  propsAsIs: true
});
const VerticalDivider = /*#__PURE__*/styled('div')({
  name: "VerticalDivider",
  class: "vviiskn",
  propsAsIs: false
});
export const SocialProof = () => {
  return <SocialProofWrapper justifyContent="center" alignItems="center" gap="s800">
      <AppRatingsAndReviews variant="AppStore" />
      <VerticalDivider />
      <TrustpilotDetails section="Hero" />
      <VerticalDivider />
      <AppRatingsAndReviews variant="GooglePlay" />
    </SocialProofWrapper>;
};

require("./SocialProof.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SocialProof.tsx");